import { Box, Typography, useTheme } from '@material-ui/core';
import { CSSProperties } from 'react';
import { WbInfoTooltip } from '../WbInfoTooltip';
import { InfoIcon } from '../Icons';

type WbFieldLabelProps = {
  label: string;
  style?: CSSProperties;
  labelInfo?: string;
};

export const WbFieldLabel = ({
  label,
  style,
  labelInfo,
}: WbFieldLabelProps) => {
  const theme = useTheme();
  const noUnderscoresLabel = label.replace(/^__/, '');

  const labelElement = (
    <Typography
      style={{
        ...style,
        color: theme.palette.secondary.dark,
        fontWeight: 600,
        display: 'block',
      }}
      variant="caption"
    >
      {noUnderscoresLabel.toUpperCase()}
    </Typography>
  );

  if (labelInfo) {
    return (
      <Box
        display="flex"
        alignItems="center"
        style={{ gap: theme.spacing(0.5) }}
      >
        {labelElement}
        <WbInfoTooltip
          title={labelInfo}
          icon={
            <InfoIcon style={{ fontSize: theme.typography.body1.fontSize }} />
          }
        />
      </Box>
    );
  }

  return labelElement;
};
